import React from "react";
import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import { allRoutes, protectedRoutes } from "../data";
const Configurations = () => {
  return (
    <>
      <Routes>
        {allRoutes.map((val, index) => {
          return <Route path={val.path} element={val.element} key={index} />;
        })}

        {protectedRoutes.map((val, index) => {
          return (
            <Route
              key={index}
              path={val.path}
              element={<PrivateRoute>{val.element}</PrivateRoute>}
            />
          );
        })}
      </Routes>
    </>
  );
};

export default Configurations;
